import { Panel } from '@appkit4/react-components/panel';
import { useNavigate } from 'react-router-dom';

interface PanelLoadProps {
  title: string;
  description: React.ReactNode;
  navigateTo: string;
  iconClass?: string;
  customIcon?: string;
  imagePath?: string;
  isActive?: boolean;
  isNew?: boolean;
}

const PanelSample = ({
  title,
  description,
  navigateTo,
  iconClass,
  customIcon,
  imagePath,
  isActive = true,
  isNew = false,
}: PanelLoadProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (isActive) {
      navigate(navigateTo);
    }
  };

  const panelClass = isActive ? 'panel-content' : 'panel-content coming-soon';

  const panelIconMap: Record<string, string> = {
    'p7m-to-pdf-xml': 'icon-lockopen-unlock-outline',
    'pdf-to-txt': 'icon-document-text-outline',
    'docompare-pdf-comparison': 'icon-document-multiple-outline',
    'doc-similarity': 'icon-dial-high-outline',
  };

  const renderCustomIcon = () => {
    if (!customIcon) return null;
    const iconName = panelIconMap[customIcon];
    if (!iconName) return null;
    return <span className={`Appkit4-icon ${iconName} panel-brand-icon`} aria-hidden="true" />;
  };

  return (
    <div className="panel-text" onClick={handleClick}>
      <Panel className={panelClass}>
        <h3>
          {iconClass && <span className={`Appkit4-icon ${iconClass}`}></span>}
          {title}
          {isNew && (
            <span className="new-badge">
              New!<span className="Appkit4-icon icon-fire-outline"></span>
            </span>
          )}
        </h3>
        <p>{description}</p>
        {customIcon && (
          <div className={`custom-icon ${customIcon}`}>
            {renderCustomIcon()}
          </div>
        )}
        {!isActive && <div className="coming-soon-badge">Coming soon</div>}
      </Panel>
    </div>
  );
};

export default PanelSample;